export const GAME_WIDTH = 1080;
export const GAME_HEIGHT = 640;

export const ROWS = 6;
export const COLUMNS = 6;

export const SYMBOL_SIZE = 74;
export const CELL_GAP_X = 16;
export const CELL_GAP_Y = 18;

export const BOARD_LEFT = 42;
export const BOARD_TOP = 28;
export const BOARD_WIDTH = 840;
export const BOARD_HEIGHT = 554;

export const ROW_LEFT = 92;
export const ROW_WIDTH = 548;
export const BOARD_X = 104;
export const BOARD_Y = 74;

export const COUNTER_X = 824;

export const LEVER_PANEL_X = 916;
export const LEVER_PANEL_Y = 28;
export const LEVER_PANEL_WIDTH = 124;
export const LEVER_PANEL_HEIGHT = 554;
export const LEVER_ROOT_X = 938;
export const LEVER_ROOT_Y = 60;

export const SYMBOLS = ['BTC', 'ETH', 'XMR', 'PUNK', 'DOGE', 'SUSHI'];
export const STAR_SYMBOL = 'STAR';

// VANGUARD reward reveal: stars are never part of the idle/random reel pool.
// A line first lands as a complete crypto-symbol line, then each cell is
// revealed into STAR only when the connected wallet is the current receiver.

export const LINE_CONFIG = [
  { key: '10', milestone: 10, reward: 10 },
  { key: '100', milestone: 100, reward: 5 },
  { key: '1000', milestone: 1000, reward: 4 },
  { key: '10000', milestone: 10000, reward: 3 },
  { key: '100000', milestone: 100000, reward: 2 },
  { key: '1000000', milestone: 1000000, reward: 1 },
];
